
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "share.icon",
  "use": "share.icon-usage",
  "viewBox": "0 0 448 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-share-nodes\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" id=\"share.icon\"><path fill=\"#747474\" d=\"M448 384c0 53.02-42.98 96-96 96s-96-42.98-96-96c0-3.984.701-7.776 1.174-11.63l-94.68-47.34C145.2 341.7 121.9 352 96 352c-53.02 0-96-42.98-96-96s42.98-96 96-96c25.86 0 49.23 10.34 66.5 26.97l94.68-47.34C256.7 135.8 256 131.1 256 128c0-53.02 42.98-96 96-96s96 42.98 96 96-42.98 96-96 96c-25.86 0-49.23-10.34-66.5-26.97l-94.68 47.34C191.3 248.2 192 252 192 256s-.7 7.8-1.2 11.6l94.68 47.34C302.8 298.3 326.1 288 352 288c53 0 96 42.1 96 96z\" /></symbol>"
});
    sprite.add(symbol);
    export default class ShareIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="share.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/share.icon.svg